/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralLookup } from '../../models/general-lookup';

export interface GetGeneralLookup$Params {
}

export function getGeneralLookup(http: HttpClient, rootUrl: string, params?: GetGeneralLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeneralLookup>>> {
  const rb = new RequestBuilder(rootUrl, getGeneralLookup.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GeneralLookup>>;
    })
  );
}

getGeneralLookup.PATH = '/api/lookuptable';
